module.exports = __webpack_public_path__ + "img/ShaqlawaView.2e17a53d.png";